import { ChangeDetectorRef, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';
import { SnackBarConfig, snackBarType } from '../constants/enum';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(public snackBar: MatSnackBar) { }


  public actionButtonSubject$ = new Subject<any>();
  actionButton$ = this.actionButtonSubject$.asObservable();


  public openSnackBar(
    message: any,
    type: any,
    duration?: any,
    verticalPosition?: any,
    horizontalPosition?: any,
    showButtonLink: boolean = true,
    showIcon: boolean = true,
    icon?: any,
    buttonText?: string | undefined,
  ) {
    const _snackType = type !== undefined ? type : 'success';
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration || 6000,
      horizontalPosition: horizontalPosition || 'end',
      verticalPosition: verticalPosition || 'top',
      data: {
        message: message,
        snackType: _snackType,
        snackBar: this.snackBar,
        showButtonLink: showButtonLink,
        showIcon: showIcon,
        icon: icon,
        buttonText: buttonText
      },
    });
  }


  acionButtonListener(data: any) {
    this.actionButtonSubject$.next(data);
  }

  showSuccessMessage(messge: string){
   
    this.openSnackBar(
      messge,
      snackBarType.Success,
      SnackBarConfig.Timer,
      SnackBarConfig.VerticalPosition,
      SnackBarConfig.HorizontalPostion,
      false,
      true,
      SnackBarConfig.CheckCircleIcon,
    );
  }
  
  showErrorMessage(messge: string){
   
    this.openSnackBar(
      messge,
      snackBarType.Error,
      SnackBarConfig.Timer,
      SnackBarConfig.VerticalPosition,
      SnackBarConfig.HorizontalPostion,
      false,
      true,
      SnackBarConfig.CheckCircleIcon,
    );
  }

}
